/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */
import React from 'react';
import {useSelector} from "react-redux";

import './RMDTable.scss';

import TableHeader from './TableHeader';
import TableBody from './TableBody';

import {getRMDSummary} from "../../../../redux/modules/RMD/RMDSetting.selectors";
import {currency} from "../../../../utils/dashboard-utils";

const RMDTable = () => {
  function showMore(e) {
    if (e) {
      e.preventDefault();
      e.target.parentElement.parentElement.parentElement.parentElement.classList.remove("minimized");
    }
  }

  const rmdSummary = useSelector(getRMDSummary);
  const showYTDColumns = rmdSummary.displayDistributionColumns;
  const pagination = rmdSummary.pagination || {};
  const currentRmdYear = rmdSummary.rmdYear;
  const totalBalance = currency(rmdSummary.totalBalance);
  const totalRMD = currency(rmdSummary.totalRMD);
  const retirementPlans = rmdSummary.retirementPlans || [];
  return (
    <div id="RMD-Table">
      <table className={(pagination.isCollapsed) ? 'minimized' : ''}>
        <TableHeader
          showYTDColumns={ showYTDColumns || null}
          currentRmdYear={currentRmdYear || null}
          totalBalance={totalBalance || null}
          totalRMD={totalRMD || null}
          rmdSummary={rmdSummary || null}
        />
        <TableBody
          showYTDColumns={ showYTDColumns || null}
          retirementPlans={retirementPlans}
          pagination={pagination}
          handleClick={(e) => {
            showMore(e);
          }}
        />
      </table>
    </div>
  );
};

export default RMDTable;
